import { INamespaceActionCreator, IReducer } from '@omaze/redux';
import { AnyAction } from 'redux';

import { SNACKBAR_ACTION } from '../../Snackbar.actions';
import {
    createSnackbarActionCreatorFactory,
    createSnackbarReducerFactory,
} from '../../Snackbar.factories';
import { ISnackbarState, ISnackbarMessage } from '../../Snackbar.state';

export const createRemoveAction: INamespaceActionCreator = createSnackbarActionCreatorFactory(
    SNACKBAR_ACTION.REMOVE,
    (id: number): number => {
        return id;
    },
);

export const removeSnackbarMessageReducer: IReducer<ISnackbarState> = createSnackbarReducerFactory(
    SNACKBAR_ACTION.REMOVE,
    (state: ISnackbarState, action: AnyAction): void => {
        state.messages = state.messages.filter((el: ISnackbarMessage): boolean => {
            return el.id !== action.payload;
        });
    },
);
